import React from "react";
import { useState, useEffect, useReducer, useRef } from "react";
import "../KeywordTrackingFromInsideApp/keyword-tracking-component.css";
import mainLogoSerpMaze from "./Telescope-frontpage.png";
import { Spinner } from "react-bootstrap";
import "./meta-title-and-description-checker-styles.css";
import { Fragment } from "react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import Loading from "../SpinnerAndError/Loading";
import {
  Bars3BottomLeftIcon,
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  UsersIcon,
  XMarkIcon,
  CodeBracketIcon,
  ComputerDesktopIcon,
  PlusCircleIcon,
  PlusSmallIcon,
} from "@heroicons/react/24/outline";

import {
  Col,
  Row,
  Card,
  Alert,
  Table,
  Tag,
  Dropdown,
  Space,
  message,
  Layout,
  Modal,
  Drawer,
  Divider,
  Input,
  Tooltip,
  AutoComplete,
  Cascader,
  DatePicker,
  InputNumber,
  Select,
  Button,
} from "antd";

import { Link, useNavigate } from "react-router-dom";
import {
  DeleteOutlined,
  UserOutlined,
  CopyOutlined,
  PieChartOutlined,
  CaretDownOutlined,
  MoreOutlined,
  CaretRightOutlined,
  PlusCircleOutlined,
  OrderedListOutlined,
  AreaChartOutlined,
  FallOutlined,
  LinkOutlined,
  RiseOutlined,
  ArrowUpOutlined,
  VerticalAlignMiddleOutlined,
  HeartOutlined,
  SketchOutlined,
  LikeOutlined,
  FireOutlined,
  ThunderboltOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const MetaAndTitleCheckerPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedMednuItem, setSelectedMenuItem] = useState("Meta checker");
  const [errorInFetching, setErrorInFetching] = useState(false);

  const [email, setEmail] = useState();
  const [overallLoading, setOverallLoading] = useState(false);

  const [firstTimeUser, setFirstTimeUser] = useState(false);
  const [isCustomerPaying, setIsCustomerPaying] = useState(false);

  const [inputForMetaTitle, setInputForMetaTitle] = useState(
    "This is how the Title appears in search results but, if it is too long ..."
  );
  const [count, setCount] = useState(0);
  const [inputForMetaDescription, setInputForMetaDescription] = useState(
    "This is the page description. Despite the meta description element's content, the text here depends on the search query and is rarely longer than 165 ..."
  );
  const [countMetaDescription, setCountMetaDescription] = useState(0);
  const [inputForURL, setInputForURL] = useState("Your webpage");
  //FOR THE DRAWER:
  const [visible, setVisible] = useState(false);

  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0); // NOT USING THIS ONE AT THE MOMENT. REACT WRITES THAT IT IS BEST NOT TO USE: https://reactjs.org/docs/hooks-faq.html
  const [reRender, setRerender] = useState(0);

  const { Header, Content, Footer, Sider } = Layout;

  //THESE ARE THE TOKENS BELOW :
  const token = window.localStorage.getItem("token");
  const token2 = token?.slice(1, -1);

  const list = [FallOutlined];

  const navigation = [
    { name: "Dashboard", icon: HomeIcon, href: "/dashboard", current: false },
    {
      name: "Keyword tracker",
      icon: ChartBarIcon,
      href: "/keyword-tracker",
      current: false,
    },
    /*   {
      name: "Reports",
      icon: UsersIcon,
      href: "/saved-reports",
      current: false,
    }, */
    {
      name: "Meta-tag generator",
      icon: ComputerDesktopIcon,
      href: "/meta-checker",
      current: true,
    },
    /*  {
      name: "Schema Markup",
      icon: CodeBracketIcon,
      href: "/schema-generator",
      current: false,
    }, */
  ];

  const avatarOnClickFunction = (event) => {
    const eventName = event.target.innerText;

    if (eventName === "Sign out") {
      logoutFunction();
    }
  };

  const userNavigation = [
    { name: "Your Profile", href: "/profile" },
    /* { name: "Settings", href: "#" }, */
    { name: "Sign out", href: "#" },
  ];

  const secondaryNavigation = [
    {
      name: "something",
      href: "#",
    },
    /* { name: "GraphQL API", href: "#" },
  { name: "Customer migration guides", href: "#" },
  { name: "Profit sharing program", href: "#" }, */
  ];

  //THIS IS THE COMPONENT DID MOUNT****************************: (IT NOW INCLUDES THE "IGNORE" WHICH IS USED TO UPDATE COMPONENTS.)
  useEffect(() => {
    if (!token) {
      localStorage.clear();
      window.location.replace("/");
    }
    fetchDataOnMount();
    setOverallLoading(true); //TURNING ON LOADER HERE
  }, [reRender]);

  const fetchDataOnMount = async () => {
    const response = await fetch(
      process.env.REACT_APP_META_AND_TITLE_CHECKER_PAGE_DATA_ON_MOUNT,
      {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token2}`,
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      setOverallLoading(false); // TURNING OFF LOADER HERE.
      setInputForURL(data.usersTrackedWebsite);
      setEmail(data.email);
    } else if (response.status === 404) {
      console.log("data not found on mount");
      setOverallLoading(false); // TURNING OFF LOADER HERE.
    } else if (response.status === 500) {
      console.log("Something went wrong");
      setOverallLoading(false); // TURNING OFF LOADER HERE.
    }
  };

  //THESE BELOW ARE FOR THE GENERAL LAYOUT USING THE ANTD DESIGN:
  const onClick = ({ key }) => {
    message.info(`Click on item ${key}`);
    setSelectedMenuItem({ key });
  };

  const typeaheadRef = useRef(null); // THIS IS USED FOR CLEARING THE INPUT FIELD IN THE "TYPEAHEAD" ON CLOSE

  // SIDER AND DRAWER TOGGLE
  const [isToggled, setToggled] = useState(false);
  const toggleTrueFalse = () => setToggled(!isToggled);
  const onClose = () => {
    setToggled(false);
  };

  const logoutFunction = () => {
    console.log("log me out please ");
    localStorage.clear();
    window.location.replace("/");
  };

  const menu = (
    <Menu
      onClick={logoutFunction}
      items={[
        /*         {
          label: "My account",
          key: "1",
        }, */
        /* {
          label: "Billing",
          key: "2",
        }, */
        {
          label: (
            <span style={{ color: "red" }} onClick={logoutFunction}>
              Logout
            </span>
          ),
          key: "3",
        },
      ]}
    />
  );
  function getItem(label, key, icon, children) {
    return {
      key,
      icon,
      children,
      label,
    };
  }

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: "4px",
      border: "1px solid #d9d9d9;",
      /* color: "black", */
      borderRadius: state.isFocused ? "4px" : "4px",
      height: "56px",
      fontColor: "#d9d9d9",
      /*       borderRadius: state.isFocused ? "3px 3px 0 0" : 3, */
      borderColor: state.isFocused ? "#28a745" : "#28a745",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "#28a745" : "#28a745",
      },
    }),
    menu: (base) => ({
      ...base,
      color: "black",
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      color: "black",
    }),
  };

  // ********** UNTIL HERE - ABOVE ARE ALL THE FUNCTIONS AND STYLES FOR THE "CHANGE GOOGLE REGION" MODAL **********

  const takeMeToTheDashboardPage = () => {
    window.location.assign("/dashboard");
  };

  let navigate = useNavigate();

  const navigateToPricesPageFunction = () => {
    navigate("/prices");
  };

  //BELOW ARE THE FUNCTION FOR SETTING THE META TILTE AND DESCRIPTION IN STATE AND COPY THEM TO CLIPBARD

  const descriptionFunction = (e) => {
    setInputForMetaDescription(e.target.value);
    countDescriptionFunction(e);
  };

  const countDescriptionFunction = (e) => {
    setCountMetaDescription(e.target.value.length);
  };

  const copyMetaDescriptionFunction = (e) => {
    if (inputForMetaDescription.length > 0) {
      navigator.clipboard.writeText(inputForMetaDescription);
      message.success("Copied to clipboard", 2.5);
    } else {
      message.error("Nothing to copy", 2.5);
    }
  };

  const titleFunction = (e) => {
    setInputForMetaTitle(e.target.value);
    countFunction(e);
  };

  const countFunction = (e) => {
    setCount(e.target.value.length);
  };

  const copyMetaTitleFunction = (e) => {
    if (inputForMetaTitle.length > 0) {
      navigator.clipboard.writeText(inputForMetaTitle);
      message.success("Copied to clipboard", 2.5);
    } else {
      message.error("Nothing to copy", 2.5);
    }
  };

  const URLFunction = (e) => {
    setInputForURL(e.target.value);
  };

  const copyURLFunction = (e) => {
    if (inputForURL.length > 0) {
      navigator.clipboard.writeText(inputForURL);
      message.success("Copied to clipboard", 2.5);
    } else {
      message.error("Nothing to copy", 2.5);
    }
  };

  //UNTIL HERE.

  return (
    <div>
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-40 md:hidden"
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
          </Transition.Child>

          <div className="fixed inset-0 z-40 flex">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="relative flex w-full max-w-xs flex-1 flex-col bg-white pt-5 pb-4">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute top-0 right-0 -mr-12 pt-2">
                    <button
                      type="button"
                      className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                      onClick={() => setSidebarOpen(false)}
                    >
                      <span className="sr-only">Close sidebar</span>
                      <XMarkIcon
                        className="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </Transition.Child>
                <div
                  style={{ cursor: "pointer" }}
                  className="flex flex-shrink-0 items-center px-4"
                >
                  <img
                    className="h-12 w-auto"
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1673349294/SerpMaze/serpMaze_xtbebq.png"
                    alt="SerpMaze"
                    onClick={takeMeToTheDashboardPage}
                  />
                </div>
                <div className="mt-5 h-0 flex-1 overflow-y-auto">
                  <nav className="space-y-1 px-2">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className={classNames(
                          item.current
                            ? "bg-gray-100 text-gray-900"
                            : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                          "group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                        )}
                      >
                        <item.icon
                          className={classNames(
                            item.current
                              ? "text-gray-500"
                              : "text-gray-400 group-hover:text-gray-500",
                            "mr-3 flex-shrink-0 h-6 w-6"
                          )}
                          aria-hidden="true"
                        />
                        {item.name}
                      </a>
                    ))}
                    {/*  <div className="space-y-1 mt-5">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "initial",
                          justifyContent: "space-between",
                          alignItems: "end",
                        }}
                      >
                        <h3
                          className="px-3 text-sm font-medium text-gray-500"
                          id="projects-headline"
                        >
                          Tracked sites
                        </h3>
                        <button
                          type="button"
                          className="inline-flex items-center rounded-full border border-transparent bg-indigo-600 p-1 text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                        >
                          <PlusSmallIcon
                            className="h-4 w-4"
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                      <div
                        className="space-y-1"
                        role="group"
                        aria-labelledby="projects-headline"
                      >
                        {secondaryNavigation.map((item) => (
                          <a
                            key={item.name}
                            href={item.href}
                            className="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                          >
                            <span className="truncate">{item.name}</span>
                          </a>
                        ))}
                      </div>
                    </div> */}
                  </nav>
                </div>
              </Dialog.Panel>
            </Transition.Child>
            <div className="w-14 flex-shrink-0" aria-hidden="true">
              {/* Dummy element to force sidebar to shrink to fit close icon */}
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}
      <div className="hidden md:fixed md:inset-y-0 md:flex md:w-64 md:flex-col">
        {/* Sidebar component, swap this element with another sidebar if you like */}
        <div className="flex flex-grow flex-col overflow-y-auto border-r border-gray-200 bg-white pt-5">
          <div
            style={{ cursor: "pointer" }}
            className="flex flex-shrink-0 items-center px-4"
          >
            <img
              className="h-12 w-auto"
              src="https://res.cloudinary.com/dfb584zgd/image/upload/v1673349294/SerpMaze/serpMaze_xtbebq.png"
              alt="SerpMaze"
              onClick={takeMeToTheDashboardPage}
            />
          </div>
          <div className="mt-5 flex flex-grow flex-col">
            <nav className="flex-1 space-y-1 px-2 pb-4">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className={classNames(
                    item.current
                      ? "bg-gray-100 text-gray-900"
                      : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                    "group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                  )}
                >
                  <item.icon
                    className={classNames(
                      item.current
                        ? "text-gray-500"
                        : "text-gray-400 group-hover:text-gray-500",
                      "mr-3 flex-shrink-0 h-6 w-6"
                    )}
                    aria-hidden="true"
                  />
                  {item.name}
                </a>
              ))}
              {/*  <div className="space-y-1 mt-5">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "initial",
                    justifyContent: "space-between",
                    alignItems: "end",
                  }}
                >
                  <h3
                    className="px-3 text-sm font-medium text-gray-500"
                    id="projects-headline"
                  >
                    Tracked sites
                  </h3>
                  <button
                    type="button"
                    className="inline-flex items-center rounded-full border border-transparent bg-indigo-600 p-1 text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                    <PlusSmallIcon className="h-4 w-4" aria-hidden="true" />
                  </button>
                </div>
                <div
                  className="space-y-1"
                  role="group"
                  aria-labelledby="projects-headline"
                >
                  {secondaryNavigation.map((item) => (
                    <a
                      key={item.name}
                      href={item.href}
                      className="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                    >
                      <span className="truncate">{item.name}</span>
                    </a>
                  ))}
                </div>
              </div> */}
            </nav>
          </div>
        </div>
      </div>
      <div className="flex flex-1 flex-col md:pl-64">
        <div className="sticky top-0 z-10 flex h-16 flex-shrink-0 bg-white shadow">
          <button
            type="button"
            className="border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <Bars3BottomLeftIcon className="h-6 w-6" aria-hidden="true" />
          </button>
          <div className="flex flex-1 justify-between px-4">
            <div className="flex flex-1">
              <form className="flex w-full md:ml-0" action="#" method="GET">
                <label htmlFor="search-field" className="sr-only">
                  Search
                </label>
                <div className="relative w-full text-gray-400 focus-within:text-gray-600">
                  {/* <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center">
                      <MagnifyingGlassIcon
                        className="h-5 w-5"
                        aria-hidden="true"
                      />
                    </div> */}
                  <span
                  /*                     id="search-field"
                    className="block h-full w-full border-transparent py-2  pr-3 text-gray-900 placeholder-gray-500 focus:border-transparent focus:placeholder-gray-400 focus:outline-none focus:ring-0 sm:text-sm"
                    placeholder={email}
                    type="search"
                    name="search" */
                  />
                </div>
              </form>{" "}
            </div>
            <div className="ml-4 flex items-center md:ml-6">
              {/* Profile dropdown */}
              <Menu as="div" className="relative ml-3">
                <div>
                  <Menu.Button className="flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                    <span className="sr-only">Open user menu</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    {userNavigation.map((item) => (
                      <Menu.Item key={item.name}>
                        {({ active }) => (
                          <a
                            onClick={avatarOnClickFunction}
                            href={item.href}
                            className={classNames(
                              active ? "bg-gray-100" : "",
                              "block px-4 py-2 text-sm text-gray-700"
                            )}
                          >
                            {item.name}
                          </a>
                        )}
                      </Menu.Item>
                    ))}
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
          </div>
        </div>

        <main className="flex-1">
          <div className="py-6">
            {/* <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
                <h1 className="text-2xl font-semibold text-gray-900">
                  Dashboard
                </h1>
              </div> */}
            <div className="">
              {" "}
              {/* mx-auto max-w-7xl px-4 sm:px-6 md:px-8 */}
              {/* Replace with your content */}
              {/*                 <div className="py-4">
                  <div className="h-96 rounded-lg border-4 border-dashed border-gray-200" />
                </div>
 */}
              {/* /End replace */}
              {overallLoading === true ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Loading />
                </div>
              ) : (
                <Content>
                  <section className="general-layout ant-layout">
                    <main className="general-layout-content ant-layout-content">
                      <div className="ant-card analysis-form-card ant-card-bordered"></div>

                      <div className="outer-wrapper-for-body-content">
                        <Col xs={24} xl={24}>
                          <Card
                            title={
                              <div className="card-title-body">
                                <span className="card-title">
                                  Meta title & description tester
                                </span>
                                <small>
                                  Test and optimise your meta titles &
                                  descriptions.
                                </small>
                              </div>
                            }
                            extra={
                              <div className="overall-seo-score-body">
                                {/*  <div className="card-link-div">
                            View report <CaretRightOutlined />
                          </div> */}
                                &nbsp;&nbsp;
                              </div>
                            }
                            style={{
                              width: "100%",
                              minHeight: "900px",
                            }}
                          >
                            {/* //The url */}
                            <Input.Group>
                              <div style={{ display: "flex" }}>
                                <p
                                  style={{ paddingRight: "5px" }}
                                  className="the-counter"
                                  /*  style={{
                              color:
                                count < 30
                                  ? "red"
                                  : count > 65
                                  ? "red"
                                  : "green",
                            }} */
                                >
                                  {<LinkOutlined />}
                                </p>

                                <Input
                                  className="input-field-meta-title"
                                  size="large"
                                  style={{
                                    width: "calc(100% - 15%)",
                                  }}
                                  defaultValue={""}
                                  onChange={URLFunction}
                                />

                                <Tooltip title="Copy meta title">
                                  {
                                    <Button
                                      className="copy-to-clipboard-button-meta-title"
                                      style={{
                                        height: "auto",
                                        width: "70px",
                                        borderRadius: "0px 4px 4px 0px",
                                        background: "#28A745",
                                        border: "#28A745 solid 1px",
                                      }}
                                      icon={
                                        <CopyOutlined
                                          style={{ color: "white" }}
                                        />
                                      }
                                      onClick={copyURLFunction}
                                    />
                                  }
                                </Tooltip>
                              </div>
                            </Input.Group>
                            <small
                              className="mt-4"
                              style={{ paddingLeft: "20px" }}
                            >
                              Try and keep it between 35 - 65 characters.
                            </small>
                            <div
                              className="outer-div-for-the-overall-seo-score-chart"
                              style={{ width: "auto", height: "500px" }}
                            >
                              <Input.Group>
                                <div style={{ display: "flex" }}>
                                  <h6
                                    className="the-counter"
                                    style={{
                                      color:
                                        count < 30
                                          ? "red"
                                          : count > 65
                                          ? "red"
                                          : "green",
                                    }}
                                  >
                                    {count}
                                  </h6>

                                  <Input
                                    className="input-field-meta-title"
                                    size="large"
                                    style={{
                                      width: "calc(100% - 15%)",
                                    }}
                                    placeholder="Title..."
                                    onChange={titleFunction}
                                  />

                                  <Tooltip title="Copy meta title">
                                    {
                                      <Button
                                        className="copy-to-clipboard-button-meta-title"
                                        style={{
                                          height: "auto",
                                          width: "70px",
                                          borderRadius: "0px 4px 4px 0px",
                                          background: "#28A745",
                                          border: "#28A745 solid 1px",
                                        }}
                                        icon={
                                          <CopyOutlined
                                            style={{ color: "white" }}
                                          />
                                        }
                                        onClick={copyMetaTitleFunction}
                                      />
                                    }
                                  </Tooltip>
                                </div>
                              </Input.Group>
                              <div className="mt-4 mb-n4">
                                <small style={{ paddingLeft: "20px" }}>
                                  Try and keep it between 120 - 165 characters.
                                </small>
                              </div>
                              <Input.Group>
                                <div style={{ display: "flex" }}>
                                  <h6
                                    className="the-counter"
                                    style={{
                                      color:
                                        countMetaDescription < 120
                                          ? "red"
                                          : countMetaDescription > 165
                                          ? "red"
                                          : "green",
                                    }}
                                  >
                                    {countMetaDescription}
                                  </h6>

                                  <Input
                                    className="input-field-meta-title mt-4"
                                    size="large"
                                    style={{
                                      width: "calc(100% - 15%)",
                                    }}
                                    placeholder="Description..."
                                    onChange={descriptionFunction}
                                  />

                                  <Tooltip title="Copy meta description">
                                    {
                                      <Button
                                        className="copy-to-clipboard-button-meta-title mt-4"
                                        style={{
                                          height: "auto",
                                          width: "70px",
                                          borderRadius: "0px 4px 4px 0px",
                                          background: "#28A745",
                                          border: "#28A745 solid 1px",
                                        }}
                                        icon={
                                          <CopyOutlined
                                            style={{ color: "white" }}
                                          />
                                        }
                                        onClick={copyMetaDescriptionFunction}
                                      />
                                    }
                                  </Tooltip>
                                </div>
                              </Input.Group>

                              <div className="title-div-onsite-result-component mt-5">
                                <div className="flag-and-title-div-onsite-result-component">
                                  {" "}
                                  <i
                                    style={{
                                      color: "#808080",
                                      fontSize: "1.5em",
                                      paddingRight: "0.5em",
                                    }}
                                    className="bi bi-signpost-2-fill"
                                  ></i>
                                  <div className="meta-title-test-and-overall-recommendation-div">
                                    <strong>
                                      Google Search Results Preview
                                    </strong>
                                    {/* <small>Site passed meta description test</small> */}
                                  </div>
                                </div>
                              </div>
                              <div className="meta-title-report-to-the-right">
                                <div className="webpage-using-a-meta-title-or-not-div desktop-text">
                                  <small>Desktop version: </small>
                                </div>
                                <div className="meta-title-and-meta-title-length-div">
                                  <div className="google-search-preview desktop">
                                    <span className="url-format">
                                      {"https://" + inputForURL}
                                    </span>
                                    <span className="title-format line-clamp lines1">
                                      {inputForMetaTitle}
                                    </span>
                                    <span className="description-format line-clamp lines2">
                                      {inputForMetaDescription}
                                    </span>
                                  </div>
                                </div>
                                <div className="webpage-using-a-meta-title-or-not-div">
                                  <small>Mobile version: </small>
                                </div>
                                <div className="meta-title-and-meta-title-length-div">
                                  <div className="google-search-preview mobile">
                                    <span className="url-format">
                                      {"https://" + inputForURL}
                                    </span>
                                    <span className="title-format line-clamp lines2">
                                      {inputForMetaTitle}
                                    </span>
                                    <span className="description-format line-clamp lines3">
                                      {inputForMetaDescription}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Card>
                        </Col>
                      </div>
                    </main>
                  </section>
                </Content>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};
export default MetaAndTitleCheckerPage;
